
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop, Ref} from 'vue-property-decorator';

  @Component({})
  export default class FileUpload extends Vue {

    @Prop({required: true})
    payloadFieldName!: string;

    @Prop({required: true})
    urlTarget!: string;

    @Prop({required: true})
    methodHttp!: 'put' | 'patch' | 'post';

    @Prop({required: false})
    hiddenInput!: boolean;

    @Prop({required: true})
    autoUpload!: boolean;

    @Prop({required: false, default: ''})
    accept!: string;

    @Prop({required: false, default: false})
    withAuthorization!: boolean;

    @Ref() fileUpload: any;
    file: File | undefined;

    onOpenFileChooser(open: boolean) {
      if (open) {
        // @ts-ignore
        this.fileUpload.click();
      }
    }

    onFileChange(file: any) {
      const files: File[] = file.target.files || file.dataTransfer.files;

      if (!files.length) {
        return;
      }

      this.file = files[0];
      if (this.autoUpload) {
        this.sendFile();
      }
    }

    sendFile() {
      if (this.file === undefined) {
        return;
      }

      const formData = new FormData();
      formData.append(this.payloadFieldName, this.file);
      if (this.methodHttp === 'patch' || this.methodHttp === 'put') {
        formData.append('_method', 'PUT')
      }
      const xhr = new XMLHttpRequest();
      xhr.open('POST', this.urlTarget);

      if (this.withAuthorization) {
        const credentials = localStorage.getItem('credentials');
        if (!credentials) {
          throw new Error(
            'Missing credentials. Maybe you want to sen without authorization',
          );
        }

        const {token_type: type, access_token: token} = JSON.parse(credentials);
        xhr.setRequestHeader('Authorization', `${type} ${token}`);
      }

      xhr.onloadstart = (e) => this.start(e);
      xhr.onloadend = (e) => this.finish(e);
      xhr.onload  = (e) => this.success();
      xhr.onerror = (err) => this.failed(err);
      xhr.upload.onprogress = this.updateProgress;
      xhr.send(formData);
    }

    updateProgress(oEvent: ProgressEvent) {
      if (oEvent.lengthComputable) {
        const percentComplete = Math.round((oEvent.loaded * 100) / oEvent.total);
        this.progress(percentComplete);
      }
    }

    @Emit()
    start(event: any): any {
      return event
    }

    @Emit()
    finish(event: any): any {
      return event
    }

    @Emit()
    failed(err: any): any {
      return err
    }

    @Emit()
    progress(value: number): number {
      return value;
    }

    @Emit()
    success() {
      return;
    }
  }
